import { render, staticRenderFns } from "./addressDialog.vue?vue&type=template&id=b585dfce&scoped=true"
import script from "./addressDialog.vue?vue&type=script&lang=js"
export * from "./addressDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b585dfce",
  null
  
)

export default component.exports